export const adminConfig = () => {
  return {
    headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` },
  };
};
